function fetchCooperationQuery (rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null
  id = rootQueryType === 'organisationalUnit' ? Number(id) : `${id}`

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null
  }

  let variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year)
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person
  }

  if (filter && filter.externalPartner && filter.externalPartner.length > 0) {
    variables['filterExternalPartner'] = filter.externalPartner
  }

  return {
    operationName: 'fetchCooperationQuery',
    query: `
      query fetchCooperationQuery($id: ID!, $pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:CooperationSortKeys, $filterYear:Int, $filterFreetext:String, $filterPerson:String, $filterExternalPartner:String) {
        ${rootQueryType}(id: $id) {
          kooperation:cooperations(pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField, filter: {year: $filterYear freeText: $filterFreetext person:$filterPerson externalPartner:$filterExternalPartner }) {
            meta {
              pageNumber
              pageSize
              totalEntries
              totalPages
            }
            entries {
              ... on Cooperation {
                _id:id
                _entityName
                html {
                  de
                  en
                }
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchCooperationQuery }



// WEBPACK FOOTER //
// ./src/graphql/cooperation.js